import { createIcon } from './createIcon'

export const RecommendedBobtailsIcon = createIcon({
  displayName: 'RecommendedBobtailsIcon',
  viewBox: '0 0 20 20',
  path: [
    <g clipPath="url(#clip0_1119_26195)" fill="none">
      <path
        d="M15.4167 18.4333C16.3371 18.4333 17.0833 17.6871 17.0833 16.7666C17.0833 15.8462 16.3371 15.1 15.4167 15.1C14.4962 15.1 13.75 15.8462 13.75 16.7666C13.75 17.6871 14.4962 18.4333 15.4167 18.4333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.79167 18.4333C5.71214 18.4333 6.45833 17.6871 6.45833 16.7666C6.45833 15.8462 5.71214 15.1 4.79167 15.1C3.87119 15.1 3.125 15.8462 3.125 16.7666C3.125 17.6871 3.87119 18.4333 4.79167 18.4333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8751 11.7667H1.44173C1.22072 11.7667 1.00876 11.8545 0.852476 12.0107C0.696196 12.167 0.608398 12.379 0.608398 12.6V15.5333C0.608398 15.8648 0.740094 16.1828 0.974515 16.4172C1.20894 16.6516 1.52688 16.7833 1.8584 16.7833H3.1084"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3748 9.68334H15.6248C15.4122 9.68372 15.2075 9.60282 15.0526 9.45719C14.8977 9.31157 14.8043 9.11224 14.7915 8.9V4.73334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8752 16.7667H6.4585"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3752 13.0167H17.3252"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0833 16.7667H18.125C18.4565 16.7667 18.7745 16.635 19.0089 16.4005C19.2433 16.1661 19.375 15.8482 19.375 15.5167V8.44166C19.3761 7.94889 19.2799 7.46076 19.0918 7.0053C18.9037 6.54983 18.6275 6.136 18.2791 5.78756C17.9307 5.43912 17.5168 5.16294 17.0614 4.97487C16.6059 4.78681 16.1178 4.69056 15.625 4.69166H11.875V16.7667H13.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 4.69165V4.16665C11.8752 3.75423 11.7733 3.34817 11.5784 2.98467C11.3836 2.62118 11.1019 2.31152 10.7583 2.08332L10 1.56665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.271 8.54169C6.16947 8.54169 7.7085 7.00267 7.7085 5.10419C7.7085 3.20571 6.16947 1.66669 4.271 1.66669C2.37252 1.66669 0.833496 3.20571 0.833496 5.10419C0.833496 7.00267 2.37252 8.54169 4.271 8.54169Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.84082 7.53419L6.70082 2.67419"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>,
    <defs>
      <clipPath id="clip0_1119_26195">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>,
  ],
})
